/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_BlogInputs */

const en_landing_footer_blog = /** @type {(inputs: Landing_Footer_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const zh_landing_footer_blog = /** @type {(inputs: Landing_Footer_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`博客`)
};

/**
* | output |
* | --- |
* | "Blog" |
*
* @param {Landing_Footer_BlogInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_footer_blog = /** @type {((inputs?: Landing_Footer_BlogInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_BlogInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_footer_blog(inputs)
	return zh_landing_footer_blog(inputs)
});
export { landing_footer_blog as "landing.footer.blog" }